import React from "react";
import { message, Popconfirm } from "antd";
import { gql, useMutation } from "@apollo/client";

const DELETEPRODUCT = gql`
  mutation removeProduct($id: ID!) {
    removeProduct(id: $id)
  }
`;

function DeleteCoreProduct({ id, name, children, onDeleteCoreProduct }) {
  const [runDeleteProduct, deleteProduct] = useMutation(DELETEPRODUCT, {
    onCompleted({ removeProduct }) {
      if (removeProduct) {
        message.success(`خدمت ${name ? name : ""} حذف شد.`);
        onDeleteCoreProduct();
      } 
    },
    onError(err) {
      message.error(err.message);
    },
  });

  const doDeleteProduct = () => {
    runDeleteProduct({
      variables: { id },
    });
  };
  return (
    <>
      <Popconfirm
        title={`حذف ${name ? `خدمت ${name}` : "خدمت"}?`}
        okText="حذف"
        cancelText="خیر"
        onConfirm={doDeleteProduct}
      >
        <span>{children}</span>
      </Popconfirm>
    </>
  );
}

export default DeleteCoreProduct;
